import Image from "./Image.vue";
import Slider from "./Slider.vue";
import Partner from "./Partner.vue";

const install = Vue => {
  Vue.component("v-img", Image)
  Vue.component("v-slider", Slider)
  Vue.component("v-partner", Partner)
};

export default {
  install
};

export { Image, Slider, Partner };